import { DataLineageFilterType, DataLineageLinkType, DataLineageSelectedFilter } from '@y42/json-schema';

export const shouldHighlight = (highlights: DataLineageSelectedFilter[], node: go.Node) => {
  const conditions: boolean[] = [];

  const connectionValues = highlights.filter((p) => p.type === DataLineageFilterType.Link).map((p) => p.value);

  if (connectionValues.length > 0) {
    if (connectionValues.includes(DataLineageLinkType.Connected)) {
      conditions.push(!!node.findNodesConnected().count);
    }

    if (connectionValues.includes(DataLineageLinkType.Unconnected)) {
      conditions.push(!node.findNodesConnected().count);
    }
  }

  return conditions.every((c) => !!c);
};
